import { LcpUserPageWrapper } from "Components/MainPageWrapper";
import { Section } from "Components/Section";
import * as React from "react";
import { DashboardLink } from "./DashboardLink";

export function ErrorPage() {
  return (
    <LcpUserPageWrapper documentTitle="Error">
      <Section title="Error">
        <p>
          Sorry, an error occurred while processing your request. Our
          development team has been notified of this issue and we will fix it as
          soon as possible.
        </p>
        <DashboardLink />
      </Section>
    </LcpUserPageWrapper>
  );
}
